module.exports = __webpack_public_path__ + "img/portails.96698bef.svg";